import { nextTick, ref } from 'vue'
import { jobCategoryApi } from '@/services/api'

export const useInfinityJobCategory = ({ search = ref(''), limit = ref(20), page = ref(0), isLoading = ref(false), list = ref([]) }) => {
  const haveMore = ref(true)
  const total = ref(0)
  const getMoreData = async () => {
    try {
      isLoading.value = true

      const searchRequest = jobCategoryApi.v2Filter({ search: search.value, limit: limit.value, page: page.value })
      const searchResponse = await searchRequest.promise
      haveMore.value = searchResponse.count.hasNextPage

      await nextTick()

      list.value = page.value === 0 ? searchResponse.docs : [...list.value, ...searchResponse.docs]

      total.value = searchResponse.count.total

      return searchResponse
    }
    catch (err) {
      console.log('err', err)
    }
    finally {
      isLoading.value = false
    }
  }

  return {
    search,
    limit,
    page,
    haveMore,
    getMoreData,
    list,
    isLoading,
    total,
  }
}
